import React from "react";
import { Contact } from "../../../interfaces/DTO/crm/contact";
import ContactTabCard from "./ContactTabCard";
import { usePartialUpdateContact } from "../../../hooks/crm/useContacts";
import { EditableField, EditableFieldsBlock } from "../../../shared/EditableFieldsBlock";
import { withNestedDataField } from "../../../utils/contactDataUtil";

interface ContactAdditionalInfoProps {
  contact: Contact;
}

const ContactAdditionalInfo: React.FC<ContactAdditionalInfoProps> = ({ contact }) => {
  const updateContact = usePartialUpdateContact();

  const handleChange = (field: string, value: string) => {
    if (!field.startsWith("data.")) {
      updateContact.mutate({ id: contact.id!, fields: { [field]: value || null } });
      return;
    }
    const parts = field.split(".");
    const nestedObject = parts[1];
    const nestedField = parts[2];

    const booleanFields = [
      "is_public_figure", "family_senior_position", "aml_service_refused",
    ];

    let processedValue: any = value;
    if (value === "" || value === null) {
      processedValue = null;
    } else if (booleanFields.includes(nestedField)) {
      processedValue = value === "1" ? true : value === "0" ? false : null;
    }

    // the whole data (a partial update replaces it as is), with only the filled in fields
    updateContact.mutate({
      id: contact.id!,
      fields: { data: withNestedDataField(contact.data, nestedObject, nestedField, processedValue) },
    });
  };

  const formalRelationsFields: EditableField[] = [
    {
      field: "data.formal_relations.is_public_figure",
      headerName: "איש/אשת ציבור?",
      value: contact.data?.formal_relations?.is_public_figure === true ? "1" : contact.data?.formal_relations?.is_public_figure === false ? "0" : "",
      type: "select",
      editable: true,
      options: [{ value: "", label: "" }, { value: "1", label: "כן" }, { value: "0", label: "לא" }],
      valueFormatter: (v) => v === "1" ? "כן" : v === "0" ? "לא" : "",
    },
    {
      field: "data.formal_relations.family_senior_position",
      headerName: "בן משפחה כיהן בתפקיד ציבורי בכיר ב-5 השנים האחרונות?",
      value: contact.data?.formal_relations?.family_senior_position === true ? "1" : contact.data?.formal_relations?.family_senior_position === false ? "0" : "",
      type: "select",
      editable: true,
      options: [{ value: "", label: "" }, { value: "1", label: "כן" }, { value: "0", label: "לא" }],
      valueFormatter: (v) => v === "1" ? "כן" : v === "0" ? "לא" : "",
    },
    {
      field: "data.formal_relations.relation_or_position",
      headerName: "קשר משפחתי/תפקיד",
      value: contact.data?.formal_relations?.relation_or_position || "",
      type: "text",
      editable: true,
    },
    {
      field: "data.formal_relations.aml_service_refused",
      headerName: "סירוב שירות בשל הלבנת הון/מימון טרור?",
      value: contact.data?.formal_relations?.aml_service_refused === true ? "1" : contact.data?.formal_relations?.aml_service_refused === false ? "0" : "",
      type: "select",
      editable: true,
      options: [{ value: "", label: "" }, { value: "1", label: "כן" }, { value: "0", label: "לא" }],
      valueFormatter: (v) => v === "1" ? "כן" : v === "0" ? "לא" : "",
    },
  ];

  return (
    <ContactTabCard contact={contact}>
      <EditableFieldsBlock
        title="קשרים משפחתיים רשמיים וציות"
        fields={formalRelationsFields}
        onChange={handleChange}
      />
    </ContactTabCard>
  );
};

export default ContactAdditionalInfo;
